import DeadlineRouter from '@/components/pages/deadline/index.vue';
import Deadlines from '@/components/pages/deadline/Deadlines.vue';
import DeadlineModification from '@/components/pages/deadline/DeadlineModification.vue';

export default {
  path: '/deadlines',
  name: 'DeadlineRouter',
  component: DeadlineRouter,
  children: [
    {
      path: '/deadlines',
      component: Deadlines,
      name: 'Deadlines',
      meta: {
        acceptRoles: ['senior', 'admin'],
      },
    },
    {
      path: '/deadlines/modification',
      component: DeadlineModification,
      name: 'DeadlineModification',
      meta: {
        acceptRoles: ['senior', 'admin'],
      },
    },
  ],
}
